<template>
  <div class="container">
    <v-app-policy :data="appMeta" />
  </div>
</template>

<script>
import AppUserPolicyView from '@/components/AppUserPolicyView.vue'

export default {
  name: 'PaintingAppUserPolicy',
  components: {
    "v-app-policy": AppUserPolicyView
  },
  data() {
    return {
      appMeta: {
        title: 'Paintings App Privacy Policy',
        appName: 'Paintings'
      }
    }
  }
}
</script>

<style scoped>
.container {
  text-align: center;
}
</style>
